<template>
	<div
		:style="`width:${externalSize}px; height: ${externalSize}px`"
		:class="[`circle display-flex align-items-center justify-content-center ${externalColorClass}`]"
	>
		<div
			:style="`width:${internalSize}px; height: ${internalSize}px`"
			:class="[`circle ${internalColorClass}`]"
		></div>
	</div>
</template>

<script>
export default {
	name: 'b-status-circle',
	props: {
		/**
		 * Tamanho do círculo externo em px
		*/
		externalSize: {
			type: Number,
			default: 24
		},
		/**
		 * Tamanho do círculo interno em px
		*/
		internalSize: {
			type: Number,
			default: 8
		},
		/**
		 * Seta a cor dos círculos, pode ser qualquer cor base disponível no DLS
		 */
		color: {
			type: String,
			default: 'blue'
		},
	},
	computed: {
		internalColorClass() {
			return `bg-${this.color}-base`
		},
		externalColorClass() {
			if(this.color == 'ink') return 'bg-white-darker-3'

			return `bg-${this.color}-lighter-4`
		},
	}
}
</script>

<style scoped lang="scss">
.circle {
	border-radius: 100%
}
</style>